export default __webpack_public_path__ + "static/iot-87c9f07a19f0e612cf245468d37249f9.png";